@let obj = data();
@let reversedLayout = reverse();
@let showIcon = !hideIcon();
<div class="tw-flex tw-flex-col">
  @if (showHeadline()) {
    <div>{{ 'lang.globals.created' | translate }}</div>
  }
  <ul class="tw-flex tw-flex-col tw-gap-2">
    <li class="tw-flex tw-items-center tw-gap-2" [class.tw-flex-row-reverse]="reversedLayout">
      @if (showIcon) {
        <sb-icon icon="clock"></sb-icon>
      }
      <div>
        @if (obj?.createdAt) {
          {{ obj?.createdAt?.toString() | date: dateFormat() }}
        } @else {
          -
        }
      </div>
    </li>
    <li class="tw-flex tw-items-center tw-gap-2" [class.tw-flex-row-reverse]="reversedLayout">
      @if (showIcon) {
        <sb-icon icon="user"></sb-icon>
      }
      <div>
        {{ obj?.createdBy?.name ?? ('lang.globals.unknown'|translate) }}
      </div>
    </li>
  </ul>
</div>
